/**
 * SMTP Configuration Service
 * 
 * Handles all SMTP configuration related API calls (admin only).
 */

import api from './api';
import type {
  SmtpConfig,
  UpdateSmtpConfigRequest,
  SmtpTestResult,
  ApiResponse,
} from '@budgira/shared';

export const smtpConfigService = {
  /**
   * Get the current SMTP configuration
   */
  async get(): Promise<ApiResponse<SmtpConfig>> {
    const response = await api.get<ApiResponse<SmtpConfig>>('/admin/smtp');
    return response.data;
  },

  /**
   * Get SMTP configuration status
   */
  async getStatus(): Promise<ApiResponse<{ configured: boolean }>> {
    const response = await api.get<ApiResponse<{ configured: boolean }>>('/admin/smtp/status');
    return response.data;
  },

  /**
   * Update the SMTP configuration
   */
  async update(data: UpdateSmtpConfigRequest): Promise<ApiResponse<SmtpConfig>> {
    const response = await api.put<ApiResponse<SmtpConfig>>('/admin/smtp', data);
    return response.data;
  },

  /**
   * Test the SMTP connection
   */
  async testConnection(): Promise<ApiResponse<SmtpTestResult>> {
    const response = await api.post<ApiResponse<SmtpTestResult>>('/admin/smtp/test');
    return response.data;
  },
};

export default smtpConfigService;
